/* VEXLARI shopping motion (v1.6)
   1. Product card -> product page: the tapped image morphs into the product photo (View Transitions).
   2. Add to cart: the photo flies into the cart, the button confirms, the new line glows.
   3. Cart drawer: lines rise in, reassurance line under checkout.
   4. Quick add: a sheet with colour + size chips from any product card (after launch only).
   Everything respects prefers-reduced-motion. */
(() => {
  const d = document.documentElement;
  const MOTION = d.classList.contains('vx-motion');
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const inr = (p) => '₹' + (p / 100).toLocaleString('en-IN', { minimumFractionDigits: p % 100 ? 2 : 0, maximumFractionDigits: 2 });
  const CHECK = '<svg class="vx-chk" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M3 8.5l3.2 3L13 4.5"/></svg>';

  /* 1. Card -> product morph */
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a.vx-card__link');
    if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    $$('.vx-card__img').forEach((i) => (i.style.viewTransitionName = ''));
    const img = a.querySelector('.vx-card__img:not(.vx-card__img--2)');
    if (img) img.style.viewTransitionName = 'vx-pimg';
  });
  addEventListener('pageshow', () => $$('.vx-card__img').forEach((i) => (i.style.viewTransitionName = '')));

  /* 2. Flight to the cart */
  const bump = () => {
    const t = $('#cart-icon-bubble');
    if (!t) return;
    t.classList.remove('vx-bump');
    void t.offsetWidth;
    t.classList.add('vx-bump');
  };
  const rowFor = (variantId) => $$('cart-drawer .cart-item, cart-items .cart-item').find((r) => r.querySelector(`a[href*="variant=${variantId}"]`));
  const flyFrom = (srcRect, src, variantId) => {
    if (!MOTION || !srcRect || !srcRect.width || !src) { bump(); return; }
    setTimeout(() => {
      const row = rowFor(variantId);
      const tgtEl = (row && row.querySelector('img')) || $('#cart-icon-bubble');
      if (!tgtEl) return;
      const b = tgtEl.getBoundingClientRect();
      const g = document.createElement('img');
      g.src = src;
      g.alt = '';
      g.className = 'vx-fly';
      Object.assign(g.style, { left: srcRect.left + 'px', top: srcRect.top + 'px', width: srcRect.width + 'px', height: srcRect.height + 'px' });
      document.body.appendChild(g);
      const dx = b.left + b.width / 2 - (srcRect.left + srcRect.width / 2);
      const dy = b.top + b.height / 2 - (srcRect.top + srcRect.height / 2);
      const s = Math.max(0.06, Math.min(b.width / srcRect.width, 0.4));
      const anim = g.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: `translate(${dx * 0.45}px, ${dy * 0.45 - 90}px) scale(${(1 + s) / 2.4})`, opacity: 1, offset: 0.55 },
        { transform: `translate(${dx}px, ${dy}px) scale(${s})`, opacity: 0.35 }
      ], { duration: 760, easing: 'cubic-bezier(.55,0,.25,1)' });
      anim.onfinish = () => {
        g.remove();
        bump();
        if (row) { row.classList.remove('vx-row-new'); void row.offsetWidth; row.classList.add('vx-row-new'); }
      };
    }, 380);
  };
  const confirmButton = (btn) => {
    if (!btn) return;
    const s = btn.querySelector('span');
    if (!s || btn.classList.contains('vx-added')) return;
    const was = s.innerHTML;
    btn.classList.add('vx-added');
    s.innerHTML = CHECK + ' Added';
    setTimeout(() => { btn.classList.remove('vx-added'); if (s.textContent.trim() === 'Added') s.innerHTML = was; }, 1800);
  };
  let lastSrc = null;
  document.addEventListener('submit', (e) => {
    const f = e.target;
    if (!f.matches || !f.matches('form[data-type="add-to-cart-form"]') || e.defaultPrevented) return;
    const img = $('.product__media-list > li.is-active img') || $('.product__media-list img');
    lastSrc = img ? { rect: img.getBoundingClientRect(), src: img.currentSrc || img.src, btn: f.querySelector('.product-form__submit') } : { btn: f.querySelector('.product-form__submit') };
  });
  const hook = () => {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, (ev) => {
      if (!ev || ev.source !== 'product-form') return;
      const s = lastSrc || {};
      confirmButton(s.btn);
      flyFrom(s.rect, s.src, ev.productVariantId);
      lastSrc = null;
    });
    return true;
  };
  if (!hook()) addEventListener('DOMContentLoaded', hook);

  /* 3. Cart reassurance line */
  const note = () => $$('.cart__ctas').forEach((c) => {
    if (c.parentElement.querySelector('.vx-cart-note')) return;
    const p = document.createElement('p');
    p.className = 'vx-cart-note';
    p.textContent = 'Free shipping across India · 7-day size exchange · Secure UPI and card payments';
    c.insertAdjacentElement('afterend', p);
  });
  const watchCart = () => {
    note();
    $$('cart-drawer, cart-items').forEach((n) => { if (!n.dataset.vxNote) { n.dataset.vxNote = '1'; new MutationObserver(note).observe(n, { childList: true, subtree: true }); } });
  };
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', watchCart) : watchCart();

  /* 4. Quick add sheet (after launch; on an unpublished preview theme also with ?vx-qa=1) */
  const qaAllowed = window.vxLive || (/[?&]vx-qa=1/.test(location.search) && window.Shopify && Shopify.theme && Shopify.theme.role !== 'main');
  if (!qaAllowed) return;
  let sheet, state;
  const build = () => {
    sheet = document.createElement('dialog');
    sheet.className = 'vx-qs';
    sheet.setAttribute('aria-labelledby', 'vx-qs-t');
    sheet.innerHTML = '<div class="vx-qs__media"><img alt="" width="1200" height="1500"></div>' +
      '<div class="vx-qs__body">' +
      '<button type="button" class="vx-qs__x" aria-label="Close"><svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13"/></svg></button>' +
      '<p class="vx-mono vx-qs__k">Drop 01</p><h2 class="vx-qs__t" id="vx-qs-t"></h2><p class="vx-qs__p"></p>' +
      '<fieldset class="vx-qs__opt" data-i="1"><legend>Colour <span data-v></span></legend><div class="vx-qs__chips"></div></fieldset>' +
      '<fieldset class="vx-qs__opt" data-i="2"><legend>Size <a href="/pages/size-guide">Size chart</a></legend><div class="vx-qs__chips"></div></fieldset>' +
      '<button type="button" class="vx-btn vx-btn--ink vx-qs__add" disabled><span>Select a size</span></button>' +
      '<p class="vx-qs__msg" role="status"></p><a class="vx-qs__more" href="#">Full details</a></div>';
    document.body.appendChild(sheet);
    const close = () => { sheet.classList.add('closing'); setTimeout(() => { sheet.classList.remove('closing'); sheet.close(); }, MOTION ? 260 : 0); };
    sheet.querySelector('.vx-qs__x').addEventListener('click', close);
    sheet.addEventListener('click', (e) => { if (e.target === sheet) close(); });
    sheet.addEventListener('cancel', (e) => { e.preventDefault(); close(); });
    sheet.querySelector('.vx-qs__add').addEventListener('click', add);
    sheet._close = close;
  };
  const variantFor = () => state.p.variants.find((v) => v.option1 === state.c && v.option2 === state.s);
  const render = () => {
    const p = state.p;
    const v = variantFor();
    const img = sheet.querySelector('.vx-qs__media img');
    const colourV = p.variants.find((x) => x.option1 === state.c && x.featured_media);
    const src = (colourV && colourV.featured_media.preview_image.src) || (p.featured_image || '');
    const sized = src ? src + (src.includes('?') ? '&' : '?') + 'width=900' : '';
    if (img.getAttribute('src') !== sized) { img.src = sized; img.alt = colourV ? colourV.featured_media.alt || p.title : p.title; }
    sheet.querySelector('.vx-qs__t').textContent = p.title.replace(' Oversized Tee', '').replace(' Oversized Hoodie', '');
    sheet.querySelector('.vx-qs__p').textContent = inr(v ? v.price : p.price) + ' · Prices include GST';
    sheet.querySelector('.vx-qs__more').href = p.url;
    sheet.querySelector('[data-i="1"] [data-v]').textContent = state.c;
    const opt = (i, values, cur, avail) => {
      const box = sheet.querySelector(`[data-i="${i}"] .vx-qs__chips`);
      box.innerHTML = '';
      values.forEach((val) => {
        const b = document.createElement('button');
        b.type = 'button';
        b.className = 'vx-chip' + (val === cur ? ' on' : '');
        b.textContent = val;
        b.setAttribute('aria-pressed', val === cur ? 'true' : 'false');
        if (!avail(val)) { b.disabled = true; b.title = 'Sold out'; }
        b.addEventListener('click', () => { if (i === 1) { state.c = val; if (state.s && !variantFor()?.available) state.s = null; } else state.s = val; render(); });
        box.appendChild(b);
      });
    };
    const o1 = p.options[0].values;
    const o2 = (p.options[1] || { values: [] }).values;
    opt(1, o1, state.c, (c) => p.variants.some((x) => x.option1 === c && x.available));
    opt(2, o2, state.s, (s) => p.variants.some((x) => x.option1 === state.c && x.option2 === s && x.available));
    const btn = sheet.querySelector('.vx-qs__add');
    const span = btn.querySelector('span');
    if (!state.s) { btn.disabled = true; span.textContent = 'Select a size'; }
    else if (!v || !v.available) { btn.disabled = true; span.textContent = 'Sold out'; }
    else { btn.disabled = false; span.textContent = 'Add to cart · ' + inr(v.price); }
    sheet.querySelector('.vx-qs__msg').textContent = '';
  };
  async function add() {
    const v = variantFor();
    if (!v) return;
    const btn = sheet.querySelector('.vx-qs__add');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    const img = sheet.querySelector('.vx-qs__media img');
    const rect = img.getBoundingClientRect();
    const src = img.currentSrc || img.src;
    try {
      const cd = $('cart-drawer');
      const sections = cd && cd.getSectionsToRender ? cd.getSectionsToRender().map((s) => s.id) : ['cart-drawer', 'cart-icon-bubble'];
      const r = await fetch((window.routes && routes.cart_add_url ? routes.cart_add_url : '/cart/add') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }], sections, sections_url: location.pathname })
      });
      const j = await r.json();
      if (!r.ok || j.status) { sheet.querySelector('.vx-qs__msg').textContent = j.description || 'Could not add this size. Try another.'; btn.disabled = false; btn.removeAttribute('aria-busy'); return; }
      sheet._close();
      if (cd && cd.renderContents) { if (cd.classList.contains('is-empty')) cd.classList.remove('is-empty'); cd.renderContents(j); }
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate, { source: 'vx-quick-add', productVariantId: v.id, cartData: j });
      flyFrom(rect, src, v.id);
    } catch (e) {
      sheet.querySelector('.vx-qs__msg').textContent = 'Network problem. Please try again.';
      btn.disabled = false;
    }
    btn.removeAttribute('aria-busy');
  }
  const open = async (handle, opener) => {
    if (!sheet) build();
    opener && opener.classList.add('busy');
    try {
      const p = await fetch(`/products/${handle}.js`).then((r) => r.json());
      const first = p.variants.find((x) => x.available) || p.variants[0];
      state = { p, c: first.option1, s: null };
      render();
      sheet.showModal();
    } catch (e) {
      location.href = `/products/${handle}`;
    }
    opener && opener.classList.remove('busy');
  };
  const addButtons = () => $$('.vx-card:not(.vx-card--pass)').forEach((card) => {
    if (card.querySelector('.vx-qa')) return;
    const a = card.querySelector('a.vx-card__link');
    const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    if (!m) return;
    const name = (card.querySelector('.vx-card__name') || {}).textContent || 'this tee';
    const b = document.createElement('button');
    b.type = 'button';
    b.className = 'vx-qa';
    b.setAttribute('aria-label', 'Quick add ' + name.trim());
    b.innerHTML = '<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M8 3v10M3 8h10"/></svg>';
    b.addEventListener('click', (e) => { e.preventDefault(); open(m[1], b); });
    card.appendChild(b);
  });
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', addButtons) : addButtons();
})();
